import React from "react";
import {
  PCHeaderWrap,
  HeaderLink,
  HeaderMenuItemWrap,
  LogoImg,
  LinkIcon,
  MenuItemWrap,
} from "./elements";
import { MenuItem } from "../elements";
import { MenuLabelList } from "..";
import Logo from "../../../assets/images/bestvalue.png";
import Home from "../../../assets/images/home.svg";
import Yamato from "../../../assets/images/yamato.svg";
import Question from "../../../assets/images/question.svg";
import Rule from "../../../assets/images/rule.svg";
import { Tel } from "../../Tel";

export const PCHeader: React.FC = () => {
  return (
    <PCHeaderWrap>
      <HeaderLink to={"/"}>
        <LogoImg alt="logo" src={Logo} />
      </HeaderLink>
      <HeaderMenuItemWrap>
        {/* <StyledLink>申し込みはこちら</StyledLink> */}
        {MenuLabelList.map(({ link, label }) => {
          return (
            <MenuItemWrap key={`menu-${label}`}>
              {link === "/" && <LinkIcon src={Home} />}
              {link === "/pickup_instructions" && <LinkIcon src={Yamato} />}
              {link === "/agreement" && <LinkIcon src={Rule} />}
              {link === "/faq" && <LinkIcon src={Question} />}
              <MenuItem key={label} to={link}>
                {label}
              </MenuItem>
            </MenuItemWrap>
          );
        })}
      </HeaderMenuItemWrap>
      <Tel />
    </PCHeaderWrap>
  );
};
